import { Swiper } from "swiper";
import type { SwiperOptions } from "swiper/types";
import { Navigation, Pagination } from "swiper/modules";

export default class LpCollaborationsSlider extends HTMLElement {
  private swiper: Swiper | null = null;

  connectedCallback() {
    // Prevent multiple initializations
    if (this.swiper) {
      return;
    }

    const $el = this.querySelector<HTMLElement>(".lp-collaborations__slider");
    
    if (!$el) {
      return;
    }

    // Check if Swiper is already initialized on this element
    if ((($el as any).swiper as Swiper)) {
      this.swiper = ($el as any).swiper as Swiper;
      return;
    }

    const $elPrev = this.querySelector<HTMLElement>(".lp-collaborations__nav--prev");
    const $elNext = this.querySelector<HTMLElement>(".lp-collaborations__nav--next");
    const $elPagination = this.querySelector<HTMLElement>(".lp-collaborations__dots");

    // Swiper options
    const swiperParams: SwiperOptions = {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    };

    // Navigation settings
    if ($elPrev && $elNext) {
      swiperParams.navigation = {
        nextEl: $elNext,
        prevEl: $elPrev,
      };
    }

    // Pagination settings
    if ($elPagination) {
      swiperParams.pagination = {
        el: $elPagination,
        clickable: true,
        bulletClass: 'lp-collaborations__dot',
        bulletActiveClass: 'lp-collaborations__dot--active',
      };
    }

    // Initialize Swiper
    this.swiper = new Swiper($el, swiperParams);

    this.updateNavVisibility();
    this.swiper.on("resize", () => this.updateNavVisibility());
  }

  private updateNavVisibility(): void {
    if (!this.swiper) return;
    const count = this.swiper.slides.length;
    const perView =
      typeof this.swiper.params.slidesPerView === "number"
        ? this.swiper.params.slidesPerView
        : 1;
    const hideNav = count <= perView;
    this.classList.toggle("lp-collaborations__slider-wrapper--nav-hidden", hideNav);
  }

  disconnectedCallback() {
    // Clean up Swiper instance when element is removed
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
